import { ReactElement } from "react";
import styles from "./FrequentlyUsedTileVisual.module.less";
import { TextSkeleton } from "client/Components";
import classNames from "classnames";

export const SkeletonFrequentlyUsedTileVisual = (): ReactElement => {
	return (
		<div
			className={classNames(
				styles.root,
				styles.root_skeleton
			)}
		>
			<div
				className={classNames(
					styles.icon,
					styles.icon_skeleton
				)}
			/>
			<TextSkeleton />
		</div>
	);
};
SkeletonFrequentlyUsedTileVisual.displayName = "SkeletonFrequentlyUsedTileVisual";